import React, { Component } from 'react';
// import './welcome.css';
import { Link } from 'react-router-dom';

/** redux **/
import autoBind from 'react-autobind';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

// Custom Components

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';

import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
  explorebtn: {
    color: 'white',
    backgroundColor: '#bb543e',
    boxShadow:
      '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    margin: '8px',
    padding: '6px 16px',
position:'relative',
right:'38%',
  },
  explorebtnMobile: {
    color: 'white',
    backgroundColor: '#bb543e',
    boxShadow:
      '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    margin: '8px',
    padding: '6px 16px',
position:'relative',
right:'24%',
  },
  welcomeHead: {
    textAlign: 'center',

  },
  welcomeHeadMobile: {
    textAlign: 'center',
    fontSize: '14px',
  },
  welcome: {
    textAlign: 'justify',

  },
  welcomeMobile: {
    textAlign: 'justify',
    fontSize: '13px',
  },
  featuredContainer: {
    padding: '20px',
    textAlign: 'left',
  },
  logo: {
    marginTop: '30px',
    marginLeft: '45%',
  },
  logoMobile: {
    marginTop: '30px',
    marginLeft: '40%',
  },
  relatedContainer: {
    marginTop: '-10px',
  },
  centering: {
    [theme.breakpoints.only('lg')]: {
      maxWidth: '75%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
});

class City extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  state = {
    open: false,
    labelWidth: 0,
    localcuisines: [],
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  componentDidMount() {
    if (sessionStorage.getItem('visit') === 'YES') {
      this.setState({
        open: false,
      });
    } else {
      sessionStorage.setItem('visit', 'YES');
      this.setState({
        open: true,
      });
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >

          {window.screen.width > 400 ? (
            <div>
               <Link to="/home">
            <img
              src="/img/logo.png"
              alt="Talking Street"
              width={60}
              height={60}
              className={classes.logo}
            />
          </Link>
              <DialogTitle
                id="form-dialog-title"
                className={classes.welcomeHead}
                >
                <span  >
                Welcome to our beta version.
                <br />  <br />
                Explore it to discover the most-recommended culinary experiences
                and tell us what you think.
                </span>
              </DialogTitle>
              <DialogContent>
              <DialogContentText
              className={classes.welcome}
              >
                <span >

                  Do excuse the bugs - we're still testing so you'll find a few
                  things that may not work perfectly. :)
                  </span>
                </DialogContentText>

              </DialogContent>
              <DialogActions>
            <Button
              onClick={this.handleClose}
              color="primary"
              className={classes.explorebtn}
            >
              Let's Explore
            </Button>
          </DialogActions>
            </div>
          ) : (
            <div>
               <Link to="/home">
            <img
              src="/img/logo.png"
              alt="Talking Street"
              width={60}
              height={60}
              className={classes.logoMobile}
            />
          </Link>
              <DialogTitle
                id="form-dialog-title"

              >
               <span  className={classes.welcomeHeadMobile}>
               Welcome to our beta version.
                <br /> <br />
                Explore it to discover the most-recommended culinary experiences
                and tell us what you think.
                 </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText >
                <span className={classes.welcomeMobile}>

                Do excuse the bugs - we're still testing so you'll find a few
                  things that may not work perfectly. :)
                </span>

                </DialogContentText>
              </DialogContent>
              <DialogActions>
            <Button
              onClick={this.handleClose}
              color="primary"
              className={classes.explorebtnMobile}
            >
              Let's Explore
            </Button>
          </DialogActions>
            </div>
          )}


        </Dialog>
      </div>
    );
  }
}

City.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(City);
